export interface MediaInfo {
    EventDateID:         number;
    ProductInfoURL:      string;
    PictureThumbnailURL: string;
}